export interface Tank {
  x: number;
  y: number;
  health: number;
  angle: number;
  power: number;
  width: number;
  height: number;
}

export interface Projectile {
  x: number;
  y: number;
  vx: number;
  vy: number;
  trail: Array<{ x: number; y: number }>;
}

export interface Explosion {
  x: number;
  y: number;
  timer: number;
  maxTimer: number;
}

export interface TankWarsGame {
  tanks: [Tank, Tank];
  turn: 0 | 1;
  projectile: Projectile | null;
  explosions: Explosion[];
  inFlight: boolean;
  winner: number | null;
  wind: number;
  message: string;
}

export const CANVAS_W = 800;
export const CANVAS_H = 500;
export const GROUND_Y = 400;
export const MAX_POWER = 100;
